import { Collection } from 'modules/core/lib/mobx-rest'

import Compensation from 'modules/attendance/store/models/Compensation'

class Compensations extends Collection<Compensation> {
  get cacheKey(): string {
    return 'compensations'
  }

  model() {
    return Compensation
  }

  get indexes() {
    return ['attendance_employees_setting_id']
  }
}
const compensations = new Compensations()
export default compensations
